import React from 'react'
import { Avatar } from '@mui/material'

const returnDate = d => {
  return new Date(d).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  })
}
const UserPlan = ({ plans }) => {
  return (
    <>
      {plans.length > 0 ? (
        <div style={{ width: '1550px' }}>
          <table className='plan_table mt-24' style={{ width: '2200px' }}>
            <thead className='plan_thead activityplan_thead'>
              <tr className='plan_thead_tr plan_tr'>
                <th className='plan_thead_tr plan_td'>Profile</th>
                <th className='plan_thead_tr plan_td'>CustomerID</th>
                <th className='plan_thead_tr plan_td'>SubscriptionID</th>
                <th className='plan_thead_tr plan_td'>Invoices</th>

                <th className='plan_thead_tr plan_td'>Plan Name</th>
                <th className='plan_thead_tr plan_td'>Start date</th>
                <th className='plan_thead_tr plan_td'>End date</th>
                <th className='plan_thead_tr plan_td'>
                  Basic/Premium Plan End Schedule
                </th>
                <th className='plan_thead_tr plan_td'>
                  Freemium Plan End Schedule
                </th>
                <th className='plan_thead_tr plan_td'>
                  Freemium Plan Expiry Reminder
                </th>
                <th className='plan_thead_tr plan_td'>
                  Freemium Plan Renew Reminder
                </th>
              </tr>
            </thead>
            <tbody className='plan_tbody activity_block'>
              {plans.map(plan => (
                <tr key={plan._id} className='plan_tbody_tr plan_tr'>
                  <td className='plan_tbody_td plan_td'>
                    <div className='d-flex plan_tbody_logo align-items-center'>
                      <Avatar src={plan?.avatar} alt='logo' />
                      <div className='ms-2'>
                        <p className='m-0'>
                          {plan?.name
                            ? plan.name
                            : `${plan?.firstname} ${plan?.lastname}`}
                        </p>
                        <p className='m-0 mt-8'>{`${plan?.email}`}</p>
                      </div>
                    </div>
                  </td>
                  <td className='plan_tbody_td plan_td'>
                    {plan?.payment?.customer_id}
                  </td>
                  <td className='plan_tbody_td plan_td'>
                    {plan?.payment?.subscription_id}
                  </td>
                  <td className='plan_tbody_td plan_td'>
                    {plan.invoices?.map((v, i) => {
                      return (
                        <>
                          <a
                            key={i}
                            href={v.invoiceLink}
                            rel='noreferrer'
                            target='_blank'
                          >
                            Invoice Link
                          </a>
                          <br />
                        </>
                      )
                    })}
                    <br />
                  </td>

                  <td
                    // onClick={() => handleopen(plan)}
                    className='plan_tbody_td plan_td pointer'
                  >
                    {plan.plan.planName}
                    {(plan?.plan?.nickname || plan.plan.service) && (
                      <>
                        {' ('}
                        {plan.plan.nickname?.split(' ')[0]}
                        {plan.plan.nickname && plan.plan.service && ' | '}
                        {plan.plan.service && `${plan.plan.service}`}
                        {')'}
                      </>
                    )}
                  </td>
                  <td className='plan_tbody_td plan_td'>
                    {new Date(plan?.plan.startDate).toLocaleDateString(
                      'en-GB',
                      {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                      }
                    )}
                  </td>
                  <td className='plan_tbody_td plan_td'>
                    {new Date(plan?.plan.endDate).toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric'
                    })}
                  </td>
                  {plan.planjobs && plan.planjobs.length > 0 ? (
                    <>
                      <td className='plan_tbody_td plan_td'>
                        {plan.planjobs
                          ?.filter(v => v.name === 'schedule-plan-dates')
                          .map((v, i) => {
                            if (v.status === 'stopped')
                              return (
                                <>
                                  <li style={{ color: 'lightgreen' }} key={i}>
                                    Success at {returnDate(v.lastRunAt)}
                                  </li>
                                </>
                              )
                            if (v.status === 'delayed')
                              return (
                                <>
                                  <li style={{ color: 'skyblue' }} key={i}>
                                    Scheduled at {returnDate(v.nextRunAt)}
                                  </li>
                                </>
                              )
                          })}
                      </td>
                      <td className='plan_tbody_td plan_td'>
                        {plan.planjobs
                          ?.filter(v => v.name === 'changeplan-to-free')
                          .map((v, i) => {
                            if (v.status === 'stopped')
                              return (
                                <>
                                  <li style={{ color: 'lightgreen' }} key={i}>
                                    Success at {returnDate(v.lastRunAt)}
                                  </li>
                                </>
                              )
                            if (v.status === 'delayed')
                              return (
                                <>
                                  <li style={{ color: 'skyblue' }} key={i}>
                                    Scheduled at {returnDate(v.nextRunAt)}
                                  </li>
                                </>
                              )
                          })}
                      </td>
                      <td className='plan_tbody_td plan_td'>
                        {plan.planjobs
                          ?.filter(v => v.name === 'plan-expiry-remainder')
                          .map((v, i) => {
                            if (v.status === 'stopped')
                              return (
                                <>
                                  <li style={{ color: 'lightgreen' }} key={i}>
                                    Success at {returnDate(v.lastRunAt)}
                                  </li>
                                </>
                              )
                            if (v.status === 'delayed')
                              return (
                                <>
                                  <li style={{ color: 'skyblue' }} key={i}>
                                    Scheduled at {returnDate(v.nextRunAt)}
                                  </li>
                                </>
                              )
                          })}
                      </td>
                      <td className='plan_tbody_td plan_td'>
                        {plan.planjobs
                          ?.filter(v => v.name === 'renew-plan')
                          .map((v, i) => {
                            if (v.status === 'stopped')
                              return (
                                <>
                                  <li style={{ color: 'lightgreen' }} key={i}>
                                    Success at {returnDate(v.lastRunAt)}
                                  </li>
                                </>
                              )
                            if (v.status === 'delayed')
                              return (
                                <>
                                  <li style={{ color: 'skyblue' }} key={i}>
                                    Scheduled at {returnDate(v.nextRunAt)}
                                  </li>
                                </>
                              )
                          })}
                      </td>
                    </>
                  ) : (
                    <>
                      <td className='plan_tbody_td plan_td'></td>
                      <td className='plan_tbody_td plan_td'></td>
                      <td className='plan_tbody_td plan_td'></td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <h2>No Plans</h2>
      )}
    </>
  )
}

export default UserPlan
